module.exports = __webpack_public_path__ + "static/Meen.756a81b8.png";